import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';
import { Observable } from 'rxjs';
import {
  CommonFlowTemperature,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsStringValueProperty,
  SecondaryHeatGeneratorCommands,
} from '@vi-iot/client/index';
import { InstallationFeaturesStore } from '@store';

@Component({
  selector: 'app-hybrid-pro-panel',
  templateUrl: './hybrid-pro-panel.component.html',
  styleUrl: './hybrid-pro-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HybridProPanelComponent implements OnInit {
  readonly featuresDetailsOverlayTypeEnum = FeaturesDetailsOverlayTypeEnum;
  readonly featurePropertyKey = FeaturePropertyKey;

  controlMode$: Observable<Feature<IsStringValueProperty, unknown>>;
  controlStrategy$: Observable<Feature<IsStringValueProperty, SecondaryHeatGeneratorCommands>>;
  temperatureOffset$: Observable<Feature<CommonFlowTemperature, unknown>>;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    this.controlMode$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.secondaryHeatGeneratorConfiguration
    );
    this.controlStrategy$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.secondaryHeatGeneratorOperatingModesActive
    );
    this.temperatureOffset$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.secondaryHeatGeneratorTemperatureOffset
    );
  }
}
